export default "__VITE_ASSET__BC_RXXTu__"